/**
 * Opens a WRO in the ShipBob dashboard, where its box labels — the "shipping mark" sent to the
 * factory — are downloaded. Works for any WRO, including ones created in ShipBob.
 *
 * Not fetched through ShipBob's API: the API's labels endpoint still serves ShipBob's OLD box-label
 * layout (no QR code), while the dashboard serves the current one the warehouse expects.
 */

import React from "react";
import { Button, Tooltip } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { shipbobWroUrl } from "shared/utils/shipbobLinks";

interface ShippingMarkButtonProps {
  wroId: string;
  variant?: "text" | "outlined" | "contained";
}

export default function ShippingMarkButton({ wroId, variant = "text" }: ShippingMarkButtonProps): JSX.Element {
  return (
    <Tooltip title="Opens this WRO in ShipBob — download the box labels (the shipping mark for the factory) there">
      <Button
        size="small"
        variant={variant}
        startIcon={<OpenInNewIcon fontSize="small" />}
        href={shipbobWroUrl(wroId)}
        target="_blank"
        rel="noopener"
        onClick={(event: React.MouseEvent) => event.stopPropagation()}
      >
        Shipping mark
      </Button>
    </Tooltip>
  );
}
